module.exports = __webpack_public_path__ + "static/ad_bg.6c85c22f.png";